import React, { useState, useEffect } from 'react';
import { ArrowUp } from 'lucide-react';
import { trackButtonClick } from '../utils/analytics';

const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 200) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    trackButtonClick('scroll_to_top', 'floating_widget');
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  if (!isVisible) return null;

  return (
    <button
      onClick={scrollToTop}
      className="fixed bottom-6 right-6 z-40 bg-[#0056D2] hover:bg-[#0A1F44] text-white p-4 rounded-full shadow-2xl transition-all duration-300 hover:scale-110 group animate-in slide-in-from-bottom-4"
      aria-label="Scroll to top"
    >
      <ArrowUp size={24} className="group-hover:-translate-y-1 transition-transform" />
    </button>
  );
};

export default ScrollToTop;